const initSelect2 = function () {
  $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
    changeSelect();
  });

  $('.custom-select-inline').on('select2:select', (e) => {
    const { data } = e.params;
    const tab = $($(`#${data.element.dataset.id}`).attr('href'));
    const links = tab[0]?.closest('.container').querySelectorAll('.nav-tabs-wrapper .nav-link');

    if (tab[0]) {
      window.tabChange(tab, links);
    }
  });

  $('.custom-select-inline').select2({
    width: 'auto',
    dropdownAutoWidth: true,
    minimumResultsForSearch: Infinity,
    tags: true,
  });
};

const initTooltip = function () {
  $('[data-toggle="tooltip"]').tooltip({ html: true });
};

function changeSelect() {
  $('.custom-select').select2({
    minimumResultsForSearch: Infinity,
    tags: true,
    allowClear: true,
  });
}

function maskInputPhone() {
  document.validatePhones();
}

document.initForms = () => {
  maskInputPhone();
  initSelect2();
  initTooltip();
  changeSelect();
};
document.addEventListener('DOMContentLoaded', () => {
  document.initForms();
});
